import { createBlueprint as t } from "@made-people/blueprint";
const o = t({
  slots: {
    base: "grid grid-cols-12 w-full first:mt-component-y-spacing-sm lg:first:mt-component-y-spacing-lg my-component-y-spacing-md lg:my-component-y-spacing-lg px-component-x-spacing-sm lg:px-component-x-spacing-lg",
    image: "aspect-[4/1] w-full object-cover rounded-lg mb-6 h-max-[25vh]",
    breadcrumbs: "text-body-sm text-text-less-emphasis-2 mb-4 [&>a:hover]:text-text-body",
    textBlockWrapper: "col-span-12",
    linkShortcutsWrapper: "col-span-12"
  },
  variants: {
    layout: {
      "straight-column": {
        image: "col-span-12",
        breadcrumbs: "col-span-12",
        textBlockWrapper: "col-span-12",
        linkShortcutsWrapper: "col-span-12"
      },
      "breadcrumbs-left": {
        base: "grid-rows-[max-content_max-content_max-content] gap-x-4",
        image: "col-span-12 row-span-1",
        breadcrumbs: "col-span-3 row-start-2 row-end-4",
        textBlockWrapper: "col-span-9 xl:col-span-6 row-start-2 row-end-3"
      }
    }
  },
  defaultVariants: {
    layout: { initial: "straight-column", lg: "breadcrumbs-left" }
  }
}), e = t({
  slots: {
    base: "grid grid-cols-12 w-full first:mt-component-y-spacing-sm lg:first:mt-component-y-spacing-lg my-component-y-spacing-md lg:my-component-y-spacing-lg px-component-x-spacing-sm lg:px-component-x-spacing-lg",
    image: "aspect-[4/1] w-full object-cover rounded-lg mb-6 h-max-[25vh]",
    breadcrumbs: "text-body-sm text-text-less-emphasis-2 mb-4 [&>a:hover]:text-text-body",
    textBlockWrapper: "col-span-12",
    linkShortcutsWrapper: "col-span-12"
  },
  variants: {
    layout: {
      "straight-column": {
        image: "col-span-12",
        breadcrumbs: "col-span-12",
        textBlockWrapper: "col-span-12",
        linkShortcutsWrapper: "col-span-12"
      },
      "breadcrumbs-left": {
        base: "grid-rows-[max-content_max-content_max-content] gap-x-4",
        image: "col-span-12 row-span-1",
        breadcrumbs: "col-span-3 row-start-2 row-end-4",
        textBlockWrapper: "col-span-9 xl:col-span-6 row-start-2 row-end-3"
      }
    }
  },
  defaultVariants: {
    layout: { initial: "straight-column", lg: "breadcrumbs-left" }
  }
});
export {
  e as pageHeaderGdanskBlueprint,
  o as pageHeaderKrakowBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
